export default "__VITE_ASSET__F0ZBL_Mt__"